import { useState } from 'react';
import { UsersPage as SharedUsersPage, type User } from '@trinetra/shared';
import { ServerStackIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import NodeAccessDialog from '../components/users/NodeAccessDialog';

/** Cloud users: no pagination; guards self-delete; per-user node access grants. */
export default function UsersPage() {
  const { user, hasPermission } = useAuth();
  const [nodeAccessUser, setNodeAccessUser] = useState<User | null>(null);
  // Granting per-node access is a user-management mutation; gate on users.edit
  // (backend enforces it too).
  const canManageAccess = hasPermission('users.edit');

  return (
    <>
      <SharedUsersPage
        currentUserId={user?.id}
        passwordMinLength={6}
        showStatus
        renderExtraActions={canManageAccess ? (u) => (
          <button
            onClick={() => setNodeAccessUser(u)}
            className="flex items-center gap-1 rounded-md px-2.5 py-1 text-[11px] font-medium text-foreground hover:bg-muted transition-colors"
            title="Manage which sites this user can access"
          >
            <ServerStackIcon className="h-3.5 w-3.5" />
            Node Access
          </button>
        ) : undefined}
      />
      {nodeAccessUser && <NodeAccessDialog user={nodeAccessUser} onClose={() => setNodeAccessUser(null)} />}
    </>
  );
}
